"use client";
import { useEffect } from "react";
import { logger } from "@/lib/logger";
import { syncUserLanguage } from "../action";

type LanguageSyncProps = {
  lang: string;
};

export function LanguageSync({ lang }: LanguageSyncProps) {
  useEffect(() => {
    // マウント時に一度だけServer Actionを呼び出す
    syncUserLanguage(lang).catch((error) => {
      logger.warn("Error syncing user language:", error);
    });
  }, [lang]);

  // このコンポーネントは何もレンダリングしない
  return null;
}
